<template>
  <div>
    <Alive31 />
    <Alive32 />
    <Alive33 />
    <Alive34 />
    <Alive35 />
    <Alive36 />
    <Alive37 />
    <Alive38 />
    <Alive39 />
  </div>
</template>
<script>
import Alive31 from '@/v2/auto/sections/31-beauty_alive.vue'
import Alive32 from '@/v2/auto/sections/32-beauty_alive.vue'
import Alive33 from '@/v2/auto/sections/33-beauty_alive.vue'
import Alive34 from '@/v2/auto/sections/34-beauty_alive.vue'
import Alive35 from '@/v2/auto/sections/35-beauty_alive.vue'
import Alive36 from '@/v2/auto/sections/36-beauty_alive.vue'
import Alive37 from '@/v2/auto/sections/37-beauty_alive.vue'
import Alive38 from '@/v2/auto/sections/38-beauty_alive.vue'
import Alive39 from '@/v2/auto/sections/39-beauty_alive.vue'
export default {
  components: {
    Alive31,
    Alive32,
    Alive33,
    Alive34,
    Alive35,
    Alive36,
    Alive37,
    Alive38,
    Alive39,
  },
}
</script>
